import React from 'react'
import BlockAccordion from '@berlitz/blocks/lib/BlockAccordion'
import Helmet from 'react-helmet'
import { getBackgroundColor } from '../../functions/utils'
import { getSerializedHTML } from '../../functions/utils'
import { SliceWrapper } from '../SliceWrapper'

const SliceAccordion = ({
  primary,
  items = [],
  pageLinks,
}) => {
  const darkBackgrounds = ['#004FEF', 'purple', '#1D1D1D']
  const hasDarkBackground = darkBackgrounds.includes(getBackgroundColor(primary.section_background_color))
  return (
    <>
      {primary.enable_structured_data && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'http://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                items &&
                  items.map(item => ({
                    '@type': 'Question',
                    name: item.accordion_title,
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: item.accordion_content.text,
                    },
                  })),
              ],
            })}
          </script>
        </Helmet>
      )}
      <SliceWrapper backgroundColor={getBackgroundColor(primary.section_background_color)} hasDarkBackground={hasDarkBackground}>
      <BlockAccordion
        backgroundColor={getBackgroundColor(primary.section_background_color)}
        title={primary.title1}
        subtitle={primary.subtitle1.text}
        items={items.map(item => ({
          title: item.accordion_title,
          content: item.accordion_content.text.includes('<table>') || item.accordion_content.text.includes('<ul>')
            ? item.accordion_content.text
            : getSerializedHTML(item.accordion_content.richText, pageLinks),
        }))}
      />

      </SliceWrapper>
    </>
  )
}

export default SliceAccordion
